import React, { useEffect } from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAutoCookieFlow } from "@noom/hive-auth";
import {
  Box,
  Stack,
  Button,
  H1,
  Link as WaxLink,
} from "@noom/wax-component-library";

import { usePageView, useAnalyticEvents } from "@app/analytics";
import { AppLayout, EmptyNavBar, CenteredLayout } from "@modules/layout";
import { useTranslation } from "react-i18next";

import LoadingPage from "./LoadingPage";

export default function LoginSelectPage() {
  const navigate = useNavigate();
  const log = useAnalyticEvents();
  usePageView("login");

  // Pass location state to Link components to preserve the correct redirect order
  const { state } = useLocation();

  const { t } = useTranslation();

  const {
    isAvailable: isAutoLoginAvailable,
    inProgress,
    login,
    error,
  } = useAutoCookieFlow();

  useEffect(() => {
    if (isAutoLoginAvailable && !inProgress && !error) {
      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if ((isAutoLoginAvailable && !error) || inProgress) {
    return <LoadingPage />;
  }

  const onSSOClick = log.onLoginWithSSO;
  const onLoginFormClick = log.onLoginWithNoom;

  return (
    <AppLayout navBar={<EmptyNavBar onLogoClick={() => navigate("/")} />}>
      <CenteredLayout>
        <Stack spacing={6} maxW="container.md">
          <Box textAlign="center">
            <H1>{t("title")}</H1>
          </Box>
          <Stack spacing={2}>
            <Link to="/login/form" onClick={onLoginFormClick} state={state}>
              <Button size="md" colorScheme="primary" variant="solid" w="100%">
                {t("signInNoom")}
              </Button>
            </Link>
            <Link to="/login/sso" onClick={onSSOClick} state={state}>
              <Button size="md" colorScheme="gray" variant="outline" w="100%">
                {t("signInOneLogin")}
              </Button>
            </Link>
          </Stack>

          <Box>
            {t("notNoomUser")}{" "}
            <WaxLink isExternal href="https://www.noom.com">
              {t("learnMoreHere")}
            </WaxLink>
          </Box>
        </Stack>
      </CenteredLayout>
    </AppLayout>
  );
}
